import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { injectIntl } from "react-intl";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import MyEmployeeTable from "./MyEmployeeTable";
import MyEmployeeFooter from "./MyEmployeeFooter";
import Enums from "../../../../utils/Enums";
import LoadingPopup from "../../../../components/LoadingPopup";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {PostAdd, ReceiptLong, Download} from '@mui/icons-material';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import UploadEmployee from "./UploadEmployee";
import PolicyCard from "../../../../components/PolicyCard";
import { coverageActions, myEmployeeActions, productActions } from "../../../../actions";
import classNames from "classnames";

class MyEmployees extends Component {
  constructor(props) {
    super(props);
    this.state = { showEmployeeTable: true, showDownloadDialog: false };
  }

  componentWillMount() {
    const { policyNumber, companyId } = this.props.location.state;
    this.props.getMyEmployees(policyNumber, companyId, {
      filterBy: "",
      filterValue: "",
      sortBy: "full_name",
      dir: Enums.SORT.ASC
    });
  }

  componentDidMount() {
    const { policyNumber, companyId } = this.props.location.state;
    if (policyNumber) {
      this.props.getGaPolicyInfo(policyNumber);
      this.props.getPolicy(policyNumber, companyId);
    }
  }

  onCellClickHandler = id => () => {
    this.toolbar.onCellClickHandler(id);
  };

  handleAddEmployee = () => {
    this.setState({ showEmployeeTable: !this.state.showEmployeeTable });
  };

  handleGoToDocuments = () => {
    const { policyNumber, companyId, company, productCode } = this.props.location.state || {};
    
    this.props.history.push({
      pathname: "/auth/documents/detail/uploadHistory",
      state: { policyNumber, companyId, company, productCode }
    });
  };

  handleOpenDownloadDialog = () => {
    this.setState({ showDownloadDialog: true });
  };

  handleCloseDownloadDialog = () => {
    if (!this.state.downloading) this.setState({ showDownloadDialog: false });
  };

  handleConfirmDownload = async () => {
    this.setState({ showDownloadDialog: false }, this.handleDownloadMemberListing);
  };

  handleDownloadMemberListing = async () => {
    const { policyNumber, companyId } = this.props.location.state || {};
    if (!policyNumber || !companyId || this.state.downloading) return;
    this.setState({ downloading: true });
    try {
      const { blob, filename } = await this.props.downloadMemberListing(policyNumber, companyId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "member-listing.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Download failed", e);
    } finally {
      this.setState({ downloading: false });
    }
  };

  render() {
    const { productCode } = this.props.location.state;
    const { classes, myEmployee, navDrawerOpen, coverage } = this.props;
    const isPCEClient = productCode === "GCP" || productCode === "PCE";
    const isPTFClient = productCode === "PF3" || productCode === "PTF" || productCode === "PEP";
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          {this.state.showEmployeeTable && (
            <div style={{ marginBottom: "90px" }}>
              <PolicyCard gaInfo={coverage.gaInfo} />
              <br />
              <div className={classes.headerTools}>
                <Typography variant="h5" color="inherit">
                  My Employees
                </Typography>
                {/* {(productCode === "GCP" || productCode === "PCE") && (
                  <Button size="small" onClick={this.handleAddEmployee}>
                    Add Employees <AddIcon />
                  </Button>
                )} */}
              </div>

              {coverage.policy && (
                <MyEmployeeTable
                  data={myEmployee.data}
                  selectedIds={myEmployee.selectedIds}
                  cellClickHandler={this.onCellClickHandler}
                  isPCEClient={isPCEClient}
                  isPTFClient={isPTFClient}
                />
              )}
            </div>
          )}
          {!this.state.showEmployeeTable && (
            <UploadEmployee
              showEmployeeTable={this.handleAddEmployee}
              navDrawerOpen={navDrawerOpen}
              renewable_status={coverage?.policy?.renewal_submitted}
            />
          )}
        </div>

        {isPTFClient && this.state.showEmployeeTable ? (
          <MyEmployeeFooter
            navDrawerOpen={navDrawerOpen}
            policyDetails={coverage}
            selectedIds={myEmployee.selectedIds}
            onRef={ref => (this.toolbar = ref)}
          />
        ) : (
          <LoadingPopup name="hr-submit-claim-on-behalf-loading" open={myEmployee.showLoading} />
        )}

        {/* Static footer for customized policy */}
        {this.state.showEmployeeTable && (productCode === "GCP" || productCode === "PCE")  && (
          <div className={classNames(classes.staticFooter, navDrawerOpen && classes.menuShow)}>
            <Button size="medium" onClick={this.handleAddEmployee} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
              <PostAdd fontSize="medium" style={{ color: "#ED1C24" }}/>Update Member Movement 
            </Button>
            <Button size="medium" onClick={this.handleOpenDownloadDialog} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
              <Download fontSize="medium" style={{ color: "#ED1C24" }}/>Download Member Listing 
            </Button>
            <Button size="medium" onClick={this.handleGoToDocuments} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
              <ReceiptLong fontSize="medium" style={{ color: "#ED1C24" }}/>View Transaction Log 
            </Button>
          </div>
        )}
        <Dialog
          open={this.state.showDownloadDialog}
          onClose={this.handleCloseDownloadDialog}
          classes={{ paper: classes.downloadDialogPaper }}
        >
          <DialogContent>
            <Typography variant="body" gutterBottom>
              <strong>Note:</strong> Member listing reflects data as at {new Date()
                .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                .toUpperCase()}.
            </Typography>
            <Typography variant="body" style={{ marginTop: 12 }}>
              If you have recently submitted a movement request, please allow up to 5 working days for
              updates to be reflected in the system.
            </Typography>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
              <Button
                variant="contained"
                color="error"
                onClick={this.handleConfirmDownload}
                disabled={this.state.downloading}
                style={{ marginLeft: 8 }}
              >
                Proceed
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    height: "100%",
    paddingTop: "40px",
    paddingLeft: "40px",
    paddingRight: "40px"
  },
  content: {
    padding: theme.spacing.unit * 2.5,
    paddingTop: 10,
    marginBottom: 65
  },
  headerTools: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px"
  },
  staticFooter: {
    backgroundColor: "white",
    position: "fixed",
    right: 0,
    bottom: 0,
    left: theme.miniLeftDrawer.widthClosed,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "10px 20px",
    gap: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  downloadDialogPaper: {
    width: 300,
    borderRadius: 4
  },
  menuShow: {
    left: theme.miniLeftDrawer.width
  }
});

function mapStateToProps(state) {
  return {
    myEmployee: state.HR.myemployee,
    loggedUser: state.user,
    coverage: state.HR.coverage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(myEmployeeActions, dispatch),
    ...bindActionCreators(productActions, dispatch),
    ...bindActionCreators(coverageActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withStyles(styles, { withTheme: true })(MyEmployees)));
